import { sendAction } from '@/core/action';


export function openExternalUrl(url: string) {
  return sendAction({
    actionId: 'openExternalBrowser',
    url,
  });
}
